'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCloseThreadMessage = undefined;

var _messageTypes = require('../constants/messageTypes');

var _isType = require('./isType');

var isCloseThreadMessage = exports.isCloseThreadMessage = (0, _isType.isType)(_messageTypes.CLOSE_THREAD);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/pubnub-message/operators/isCloseThreadMessage.js
// module id = 588
// module chunks = 2 3